import { makeDataStore } from '../y/data-store';
import { YCountryId, YId } from '../y/types';

export interface UCoordinates {
    lat: number;
    lng: number;
}

export interface CCity {
    id: YId;
    name: string;
    country: YCountryId;
    slug: string;
    location: UCoordinates;
    can_signup: boolean;
}

export const c_cities = makeDataStore('new_cities', 'city', (m: CCity) => m, Object.assign);

declare global {
    interface Window {
        ab_cities?: CCity[];
    }
}

if(window.ab_cities)
    c_cities.init(window.ab_cities);

export function cCityBySlug(slug: string) {
    return c_cities.all.find(c => c.slug == slug);
}
